// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoToast-module__wrapper--f4ae3"};